"use client";
import "@/modules/lib/observability/datadogInit";
import { LayoutWrapper } from "@/components/LayoutWrapper";
import * as messagesDE from "@/locales/de/common.json";
import * as messagesEN from "@/locales/en/common.json";
import * as messagesES from "@/locales/es/common.json";
import * as messagesNL from "@/locales/nl/common.json";
import { logger } from "@/modules/lib/observability/logger";
import { ThemeProvider } from "@/modules/theme";
import StyledComponentsRegistry from "@/modules/theme/StyledSheetManager";
import { ErrorScreen } from "@/screens/Error";
import { NextIntlClientProvider } from "next-intl";
import { Inter } from "next/font/google";
import { useParams } from "next/navigation";
import { Suspense, useEffect } from "react";

const inter = Inter({
  subsets: ["latin"],
  weight: ["400", "500", "700", "800", "900"],
  variable: "--font-inter",
  display: "swap",
});

const getMessages = (locale: string) => {
  switch (locale) {
    case "en":
      return messagesEN;
    case "es":
      return messagesES;
    case "nl":
      return messagesNL;
    default:
      return messagesDE;
  }
};

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const params = useParams();
  const locale = (params.locale as string) || "en";

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    logger.error(error.message);
  }, []);

  return (
    <html lang={locale} className={inter.className}>
      <body>
        <StyledComponentsRegistry>
          <Suspense fallback={<div>Loading...</div>}>
            <ThemeProvider>
              <NextIntlClientProvider
                locale={locale}
                messages={getMessages(locale)}
              >
                <LayoutWrapper>
                  <ErrorScreen />
                </LayoutWrapper>
              </NextIntlClientProvider>
            </ThemeProvider>
          </Suspense>
        </StyledComponentsRegistry>
      </body>
    </html>
  );
}
